/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiTilePattern,
    ApiTilePatternFromJSON,
    ApiTilePatternFromJSONTyped,
    ApiTilePatternToJSON,
    DisplayPrice,
    DisplayPriceFromJSON,
    DisplayPriceFromJSONTyped,
    DisplayPriceToJSON,
    OutBopSummary,
    OutBopSummaryFromJSON,
    OutBopSummaryFromJSONTyped,
    OutBopSummaryToJSON,
    OutBopUpdate,
    OutBopUpdateFromJSON,
    OutBopUpdateFromJSONTyped,
    OutBopUpdateToJSON,
} from './';

/**
 * 
 * @export
 * @interface OutBop
 */
export interface OutBop {
    /**
     * 
     * @type {Array<OutBopSummary>}
     * @memberof OutBop
     */
    summaries?: Array<OutBopSummary> | null;
    /**
     * 
     * @type {Array<OutBopUpdate>}
     * @memberof OutBop
     */
    updates?: Array<OutBopUpdate> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OutBop
     */
    isSummary: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutBop
     */
    totalPriceText?: string | null;
    /**
     * 
     * @type {DisplayPrice}
     * @memberof OutBop
     */
    totalPrice: DisplayPrice;
    /**
     * 
     * @type {string}
     * @memberof OutBop
     */
    modelId: string;
    /**
     * 
     * @type {string}
     * @memberof OutBop
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof OutBop
     */
    configString?: string | null;
    /**
     * 
     * @type {ApiTilePattern}
     * @memberof OutBop
     */
    activePattern?: ApiTilePattern | null;
    /**
     * 
     * @type {Array<ApiTilePattern>}
     * @memberof OutBop
     */
    availablePatterns?: Array<ApiTilePattern> | null;
}

export function OutBopFromJSON(json: any): OutBop {
    return OutBopFromJSONTyped(json, false);
}

export function OutBopFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutBop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'summaries': !exists(json, 'summaries') ? undefined : (json['summaries'] === null ? null : (json['summaries'] as Array<any>).map(OutBopSummaryFromJSON)),
        'updates': !exists(json, 'updates') ? undefined : (json['updates'] === null ? null : (json['updates'] as Array<any>).map(OutBopUpdateFromJSON)),
        'isSummary': json['isSummary'],
        'totalPriceText': !exists(json, 'totalPriceText') ? undefined : json['totalPriceText'],
        'totalPrice': DisplayPriceFromJSON(json['totalPrice']),
        'modelId': json['modelId'],
        'category': json['category'],
        'configString': !exists(json, 'configString') ? undefined : json['configString'],
        'activePattern': !exists(json, 'activePattern') ? undefined : ApiTilePatternFromJSON(json['activePattern']),
        'availablePatterns': !exists(json, 'availablePatterns') ? undefined : (json['availablePatterns'] === null ? null : (json['availablePatterns'] as Array<any>).map(ApiTilePatternFromJSON)),
    };
}

export function OutBopToJSON(value?: OutBop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'summaries': value.summaries === undefined ? undefined : (value.summaries === null ? null : (value.summaries as Array<any>).map(OutBopSummaryToJSON)),
        'updates': value.updates === undefined ? undefined : (value.updates === null ? null : (value.updates as Array<any>).map(OutBopUpdateToJSON)),
        'isSummary': value.isSummary,
        'totalPriceText': value.totalPriceText,
        'totalPrice': DisplayPriceToJSON(value.totalPrice),
        'modelId': value.modelId,
        'category': value.category,
        'configString': value.configString,
        'activePattern': ApiTilePatternToJSON(value.activePattern),
        'availablePatterns': value.availablePatterns === undefined ? undefined : (value.availablePatterns === null ? null : (value.availablePatterns as Array<any>).map(ApiTilePatternToJSON)),
    };
}


